(() => {
  const stripOverflowHidden = () => {
    // remove overflow-hidden + overflow-hidden-* (e.g. overflow-hidden-tablet)
    for (const c of [...document.body.classList]) {
      if (c === "overflow-hidden" || c.startsWith("overflow-hidden-")) {
        document.body.classList.remove(c);
      }
    }
    document.body.style.overflow = "";
  };

  const closeMenu = () => {
    // Dawn-style drawer
    document.querySelectorAll("header details[open]").forEach(d => d.removeAttribute("open"));
    // fallback: click any close button if theme uses one
    document.querySelector(".menu-drawer__close-button,[aria-label='Close']")?.click();
  };

  document.addEventListener("click", (e) => {
    const a = e.target.closest("a[href]");
    if (!a) return;

    const href = a.getAttribute("href") || "";
    const hash = (href.startsWith("/#") ? href.slice(1) : href.startsWith("#") ? href : null);
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();

    closeMenu();
    stripOverflowHidden();

    history.pushState(null, "", hash);
    requestAnimationFrame(() => target.scrollIntoView({ behavior: "smooth", block: "start" }));
  });
})();
